/**
 * 订单状态名称常量
 */
export const CREATED = 'CREATED'
export const COMPLETED = 'COMPLETED'
export const CANCELLED = 'CANCELLED'
export const REFUNDED = 'REFUNDED'
export const DELETED = 'DELETED'
export const CLOSED = 'CLOSED'
export const PAYMENT_COMPLETE = 'PAYMENT_COMPLETE'
export const HG_SHIPPED = 'HG_SHIPPED'
export const HG_SAMPLES_COLLECTED = 'HG_SAMPLES_COLLECTED'
export const HG_2_LAB_SAMPLES_SHIPPED = 'HG_2_LAB_SAMPLES_SHIPPED'
export const LAB_SAMPLES_RECEIVED = 'LAB_SAMPLES_RECEIVED'
export const LAB_DNA_READY = 'LAB_DNA_READY'
export const LAB_DNA_TESTED = 'LAB_DNA_TESTED'
export const HG_REPORT_CREATED = 'HG_REPORT_CREATED'
export const HG_REPORT_OK = 'HG_REPORT_OK'
export const HG_REPORT_SENT = 'HG_REPORT_SENT'
export const REFUND_REQUESTED = 'REFUND_REQUESTED'
export const CONSULTANT_CONTACTED = 'CONSULTANT_CONTACTED'
export const DOCTOR_INTERPRETED = 'DOCTOR_INTERPRETED'
// 远盟 - 报告审核
export const REPORT_CHECKED_1ST = 'REPORT_CHECKED_1ST'
// 远盟 - 报告批准
export const REPORT_CHECKED_2ND = 'REPORT_CHECKED_2ND'
// 远盟 - 报告盖章
export const REPORT_STAMPED = 'REPORT_STAMPED'
// develop-2.0 ADD
export const DATA_ANALYSISED = 'DATA_ANALYSISED'
// 样本回退，样本重采
export const LAB_SAMPLE_RETURNED = 'LAB_SAMPLE_RETURNED'
export const CREATE = 'CREATE'
// 样本回寄
export const SAMPLE_RETURNED = 'SAMPLE_RETURNED'
// hg报告生成
export const REPORT_CREATED = 'REPORT_CREATED'
// 样本制备
export const PREPARED = 'PREPARED'
// 样本入库
export const WAREHOUSING = 'WAREHOUSING'
